// Mock data for Silent Sentry, LLC landing page (frontend-only)
import {
  ShieldCheck, Cloud, BrainCircuit, Network, Phone, Headset, Radio,
} from "lucide-react";

export const company = {
  name: "SILENT SENTRY",
  legalName: "Silent Sentry, LLC",
  tagline: "Guarding Systems. Empowering Growth. Architecting the Future.",
  overline: "Enterprise Technology Advisory",
  subtext:
    "Vendor-neutral technology brokerage with defense-first engineering. We evaluate 400+ top-tier suppliers to architect resilient cloud, network, and AI solutions for regional and federal clients.",
  email: "janthony@silentsentrycorp.com",
  contactEmail: "service@silentsentrycorp.com",
  website: "www.silentsentry.com",
  location: "Omaha, Nebraska",
  serving: "Serving Regional & Federal Clients",
};

export const stats = [
  { value: "400+", label: "Suppliers Evaluated" },
  { value: "7", label: "Solution Domains" },
  { value: "$0", label: "Cost To You — Supplier Funded" },
  { value: "24/7", label: "Lifecycle Support" },
];

export const solutions = [
  {
    icon: ShieldCheck,
    title: "Cybersecurity & Risk Management",
    slug: "cybersecurity-risk-management",
    desc: "MDR/EDR, SOC-as-a-Service, SIEM, Zero Trust, Incident Response, Vulnerability Assessments & GRC Compliance (NIST 800-53, CMMC, HIPAA, PCI).",
  },
  {
    icon: Cloud,
    title: "Cloud Infrastructure & Managed Services",
    slug: "cloud-infrastructure-managed-services",
    desc: "Public, Private & Hybrid Cloud Migration, Multi-Cloud Orchestration, IaaS/PaaS, Disaster Recovery (DRaaS) & Backup Solutions.",
  },
  {
    icon: BrainCircuit,
    title: "Artificial Intelligence & Automation",
    slug: "ai-automation",
    desc: "AI Readiness Assessments, Generative AI Roadmapping, Predictive Analytics, Process Automation & AI Security Governance.",
  },
  {
    icon: Network,
    title: "Advanced Networking & Connectivity",
    slug: "advanced-networking-connectivity",
    desc: "SD-WAN, SASE Architecture, Dedicated Internet Access (DIA), Cloud On-Ramps, Fiber, Satellite & POTS Replacement.",
  },
  {
    icon: Phone,
    title: "Unified Communications (UCaaS)",
    slug: "unified-communications-ucaas",
    desc: "Cloud Voice, Microsoft Teams & Zoom Integration, Mobile Workforce Collaboration & Hybrid Communications Architecture.",
  },
  {
    icon: Headset,
    title: "Contact Center & CX Technology (CCaaS)",
    slug: "contact-center-ccaas",
    desc: "Omnichannel Customer Journey, AI Self-Service Bot Integration, Workforce Engagement (WEM) & Predictive Analytics.",
  },
  {
    icon: Radio,
    title: "IoT & Mobility Solutions",
    slug: "iot-mobility-solutions",
    desc: "Enterprise Mobility Management (EMM), IoT Sensor Networks, Smart Fleet Tracking & Privacy-Compliant Mobile Connectivity.",
  },
];

export const processSteps = [
  { num: "01", title: "Discover", desc: "Deep-dive assessment of your environment, technical constraints, compliance mandates, and growth objectives." },
  { num: "02", title: "Design", desc: "Defense-first solution architecture engineered through a cybersecurity lens to eliminate vulnerabilities before they exist." },
  { num: "03", title: "Negotiate", desc: "Vendor-neutral evaluation across 400+ suppliers to secure optimal terms, pricing, and SLAs on your behalf." },
  { num: "04", title: "Deploy", desc: "Hands-on deployment oversight and project coordination — from contract signature through go-live." },
  { num: "05", title: "Optimize", desc: "Ongoing lifecycle support, performance reviews, and continuous optimization as your business evolves." },
];

export const suppliers = [
  { name: "AT&T", domain: "att.com" },
  { name: "Verizon", domain: "verizon.com" },
  { name: "Lumen", domain: "lumen.com" },
  { name: "Comcast Business", domain: "comcast.com" },
  { name: "Spectrum", domain: "spectrum.com" },
  { name: "Cox Business", domain: "cox.com" },
  { name: "Zayo", domain: "zayo.com" },
  { name: "Windstream", domain: "windstream.com" },
  { name: "Frontier", domain: "frontier.com" },
  { name: "Granite", domain: "granitenet.com" },
  { name: "GTT", domain: "gtt.net" },
  { name: "Aryaka", domain: "aryaka.com" },
  { name: "Fortinet", domain: "fortinet.com" },
  { name: "Palo Alto", domain: "paloaltonetworks.com" },
  { name: "Zscaler", domain: "zscaler.com" },
  { name: "Cloudflare", domain: "cloudflare.com" },
  { name: "Arctic Wolf", domain: "arcticwolf.com" },
  { name: "Check Point", domain: "checkpoint.com" },
  { name: "AWS", domain: "aws.amazon.com" },
  { name: "Microsoft Azure", domain: "microsoft.com" },
  { name: "Google Cloud", domain: "cloud.google.com" },
  { name: "Rackspace", domain: "rackspace.com" },
  { name: "11:11 Systems", domain: "1111systems.com" },
  { name: "Flexential", domain: "flexential.com" },
  { name: "RingCentral", domain: "ringcentral.com" },
  { name: "Zoom", domain: "zoom.us" },
  { name: "8x8", domain: "8x8.com" },
  { name: "Dialpad", domain: "dialpad.com" },
  { name: "Nextiva", domain: "nextiva.com" },
  { name: "Vonage", domain: "vonage.com" },
  { name: "Five9", domain: "five9.com" },
  { name: "NICE CXone", domain: "nice.com" },
  { name: "Talkdesk", domain: "talkdesk.com" },
  { name: "Genesys", domain: "genesys.com" },
  { name: "Cato Networks", domain: "catonetworks.com" },
  { name: "Cradlepoint", domain: "cradlepoint.com" },
];

export const testimonial = {
  quote:
    "Silent Sentry cut through months of vendor noise in weeks. Their defense-first architecture and CMMC expertise gave us a network we trust — at a price we negotiated once and never worried about again.",
  name: "Operations Director",
  role: "Regional Defense Contractor · Midwest",
};

export const resources = [
  {
    tag: "Cybersecurity",
    slug: "zero-trust-2026",
    title: "Zero Trust in 2026: A Practical Roadmap for Mid-Market Enterprises",
    img: "https://images.unsplash.com/photo-1614064548237-096f735f344f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5JTIwYWJzdHJhY3R8ZW58MHx8fHwxNzg3MDc1NDUyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "Cloud",
    slug: "draas-vs-backup",
    title: "DRaaS vs. Backup: Guaranteeing Continuity When Disruption Strikes",
    img: "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    tag: "AI & Automation",
    slug: "ai-readiness-governance",
    title: "AI Readiness: Governance Questions to Answer Before You Deploy",
    img: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlJTIwYWJzdHJhY3R8ZW58MHx8fHwxNzg3MDc1NDUyfDA&ixlib=rb-4.1.0&q=85",
  },
];

export const whyUs = [
  { title: "Vendor-Neutral Advisory", desc: "We evaluate 400+ technology suppliers to curate optimal solutions tailored to your technical constraints and budget — never a quota." },
  { title: "Defense-First Engineering", desc: "Every solution architecture is designed through a cybersecurity lens, ensuring your defenses remain impenetrable." },
  { title: "Public & Enterprise Expertise", desc: "Deep experience supporting state government operations, defense sector compliance (CMMC/NIST), and mission-critical environments." },
  { title: "Lifecycle Support", desc: "A dedicated partner from discovery and design to contract negotiation, deployment oversight, and ongoing optimization." },
];

export const heroImg =
  "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGRhcmslMjBuZXR3b3JrJTIwZ2VvbWV0cmljJTIwbm9kZXN8ZW58MHx8fHwxNzg3MDc1NDYxfDA&ixlib=rb-4.1.0&q=85";

export const contactBg =
  "https://images.pexels.com/photos/35017775/pexels-photo-35017775.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
